import { DateTime } from "luxon";

function multiKeyCompare<T extends object>(
  inputArray: Array<T>,
  initialAscOrder: boolean,
  keys: (keyof T)[]
): Array<T> {
  const parseValue = (value: any, key: keyof T) => {
    if (value === null) return null;

    // Auto-detect date fields by key name
    if (
      typeof value === "string" &&
      (key.toString().toLowerCase().includes("createdat") ||
        key.toString().toLowerCase().includes("nextscheduledexam") ||
        key.toString().toLowerCase().includes("dateofbirth"))
    ) {
      return DateTime.fromISO(value, { zone: "utc" }).startOf("day").toMillis();
    }

    if (typeof value === "string") {
      return value.trim().toLowerCase();
    }

    return value;
  };

  return [...inputArray].sort((a: T, b: T) => {
    let returnVal = 0;

    keys.forEach((key, index) => {
      // Only compare other keys if the previous results were equal
      if (returnVal === 0) {
        let isAscending = initialAscOrder;

        // Always ascending for firstName and lastName
        if (
          (key === "firstName" && index !== 0) ||
          (key === "lastName" && index !== 0) ||
          (key === "patientName" && index !== 0)
        ) {
          isAscending = true;
        }
        // Always descending for completionDate when not the first index.
        else if (key === "completionDate" && index !== 0) {
          isAscending = false;
        }

        const valueA = parseValue(a[key], key);
        const valueB = parseValue(b[key], key);

        if (valueA < valueB) returnVal = isAscending ? -1 : 1;
        if (valueA > valueB) returnVal = isAscending ? 1 : -1;
      }
    });

    return returnVal;
  });
}

export { multiKeyCompare };
